'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SELECTORS = {
  wrapper: '.c-gutenberg__content',
  block: '.wp-block-yoast-faq-block',
  section: '.schema-faq-section',
  question: '.schema-faq-question',
  answer: '.schema-faq-answer'
};

// Markup feeds Yoast's FAQPage schema — touch ARIA and visibility only.
var bindPair = function bindPair(question, answer, index) {
  var answerId = answer.id || 'faq-answer-' + index;
  var questionId = question.id || 'faq-question-' + index;

  answer.id = answerId;
  question.id = questionId;

  question.setAttribute('role', 'button');
  question.setAttribute('tabindex', '0');
  question.setAttribute('aria-controls', answerId);
  question.setAttribute('aria-expanded', 'false');
  answer.setAttribute('aria-labelledby', questionId);
  answer.hidden = true;

  var toggle = function toggle() {
    var isOpen = question.getAttribute('aria-expanded') === 'true';
    question.setAttribute('aria-expanded', String(!isOpen));
    answer.hidden = isOpen;
  };

  question.addEventListener('click', toggle);

  question.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      toggle();
    }
  });
};

exports.default = {
  init: function init() {
    var wrapper = document.querySelector(SELECTORS.wrapper);

    if (!wrapper) return;

    var blocks = wrapper.querySelectorAll(SELECTORS.block);

    if (!blocks.length) return;

    var index = 0;

    blocks.forEach(function (block) {
      block.querySelectorAll(SELECTORS.section).forEach(function (section) {
        var question = section.querySelector(SELECTORS.question);
        var answer = section.querySelector(SELECTORS.answer);

        if (!question || !answer) return;

        bindPair(question, answer, index);
        index += 1;
      });
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/components/faq-accordion.js